import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EgiAppListComponent } from './components/containers/egi-app-list/egi-app-list.component';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { EgiAppEditorViewComponent } from './components/views/egi-app-editor-view/egi-app-editor-view.component';
import { NavigationItemEditorComponent } from './components/containers/navigation-item-editor/navigation-item-editor.component';
import { FormlyModule } from '@ngx-formly/core';
import { NavigationItemTreeModule } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-tree.module';
import { EgiPageDragListComponent } from './components/containers/egi-page-drag-list/egi-page-drag-list.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NavigationItemConfiguratorComponent } from './components/containers/navigation-item-configurator/navigation-item-configurator.component';
import { PlatformContextModule } from '@/app/platform/platform-context/platform.context.module';
import { PlatformManagementDataModule } from '@/app/platform/platform-data/platform-management-data.module';

@NgModule({
  declarations: [
    EgiAppListComponent,
    EgiAppEditorViewComponent,
    NavigationItemEditorComponent,
    EgiPageDragListComponent,
    NavigationItemConfiguratorComponent
  ],
  exports: [EgiAppListComponent, EgiAppEditorViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    PlatformManagementDataModule,
    FormlyModule,
    SharedModule,
    NavigationItemTreeModule,
    PlatformContextModule,
    MatTreeModule,
    MatMenuModule,
    DragDropModule
  ],
  providers: []
})
export class EgiAppManagementBlockModule {}
